import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Navbar from "./Navbar.jsx";
import Inicio from "./Inicio.jsx";
import QueEs from "./QueEs.jsx";
import QuienesSomos from "./QuienesSomos.jsx";
import Historico from "./Historico.jsx";
import Colabora from "./Colabora.jsx";
import Patrocinadores from "./Patrocinadores.jsx";
import Entrena from "./Entrena.jsx";
import MaterialesExtra from "./MaterialesExtra.jsx";
import Concursos from "./Concursos.jsx";
import Inscripcion from "./Inscripcion.jsx";
import Contacto from "./Contacto.jsx";
import Footer from "./Footer.jsx";
import ScrollToTop from "./ScrollToTop.jsx";

import "./css/style.css";
import '@fontsource/poppins'; // Importa el peso regular por defecto
import '@fontsource/poppins/700.css'; // Importa el peso Bold

export default function Root() {
    return (
        <BrowserRouter>
        
            <ScrollToTop />
            <Navbar/>

            <div id="view">
                <Routes>
                    <Route path="/" element={<Inicio />}/>
                    <Route path="/que-es" element={<QueEs />}/>
                    <Route path="/quienes-somos" element= {<QuienesSomos/>}/>
                    <Route path="/historico" element={<Historico/>}/>
                    <Route path="/colabora" element={<Colabora/>}/>
                    <Route path="/patrocinadores"element={<Patrocinadores/>}/>
                    <Route path="/temario" element={<Entrena/>}/>
                    <Route path="/materiales-extra" element={<MaterialesExtra/>}/>
                    <Route path="/concursos" element={<Concursos/>}/>
                    <Route path="/contacto" element={<Contacto />}/>
                    <Route path="/inscripcion" element={<Inscripcion />}/>
                </Routes>
            </div>
            <Footer />
        </BrowserRouter>
    );
}

const rootElement = document.getElementById("root");
if (rootElement) {
    createRoot(rootElement).render(<Root/>);
}